import * as s from "styles/ModalCommonStyled";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { SearchAccount } from "components/element/search/SearchAccount";
import { UserGroupCURequest } from "api/interfaces/userInterface.interface";
import { UPDATE_TYPE } from "../AddUserGroupContainer";

interface AccountsStepPageProps {
  accountId: string;
  isEditableUser: boolean;
  madeUserGroupUserId: string;
  isDisabledAutoApply: boolean;
  userGroup: UserGroupCURequest;
  onChangeGroupInfo: (type: UPDATE_TYPE, value: any) => void;
}

export default function AccountsStepPage(
  props: AccountsStepPageProps
): JSX.Element {
  return (
    <>
      <s.CheckInput>
        <input
          type="checkbox"
          defaultChecked={props.userGroup.autoApplyAccount}
          checked={props.userGroup.autoApplyAccount}
          disabled={props.isDisabledAutoApply}
          onChange={(e) =>
            props.onChangeGroupInfo(
              UPDATE_TYPE.AUTO_APPLY_ACCOUNT,
              e.target.checked
            )
          }
          data-testid="users-usersgroup-input-auto-apply-account"
        />
        Apply to all current and future Organization.
      </s.CheckInput>

      <s.ModalTableContainer>
        {!(
          props.userGroup.userPermission.enableAllPermissions ||
          props.userGroup.autoApplyAccount
        ) && (
          <ModalInput label="Add Organization">
            <SearchAccount
              accountId={props.accountId}
              selectedAccountId={props.userGroup.accounts}
              disabled={!props.isEditableUser}
              allSelect={props.userGroup.userPermission.enableAllPermissions}
              onSelectedRowsChange={(value: string[]) => {
                props.onChangeGroupInfo(UPDATE_TYPE.ACCOUNT, value);
              }}
              userId={props.madeUserGroupUserId}
            />
          </ModalInput>
        )}
      </s.ModalTableContainer>
    </>
  );
}
